import * as React from "react";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Grid, Paper } from "@mui/material";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#212121',
        },
    },
  });

export const Page404 = () => {

    return (
        <ThemeProvider theme={darkTheme}>
            <Box sx={{ flexGrow: 1, marginLeft:"10px",}}>
                <Grid container spacing={2} marginTop="60px" xs={12} >
                    <Grid item xs={12}>
                        <Paper elevation={300} sx={{height:500, display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <img src="/page404.png" alt="En construcción" /*style={{height: "100%", overflow:"hidden"}}*//>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    );
};
